import Button from '@mui/material/Button';
import { green } from '@mui/material/colors';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

const SuccessClinic = ({ clinicName, closeHandler, nextPage }) => {
  const buttonHandler = () => {
    nextPage();
    closeHandler();
  };

  return (
    <div className="panel-content">
      <div style={{ marginBottom: '20px' }}>
        <CheckCircleOutlineIcon style={{ color: green[800], fontSize: 48 }} />
        <br />
        <h2>
          <FormattedMessage
            defaultMessage="You've been successfully associated with {clinicName}"
            values={{ clinicName }}
          />
        </h2>
      </div>
      <div className="bottom-bar">
        <div className="flex-left">
          <Button
            className="rounded-button-teal"
            type="button"
            onClick={buttonHandler}
          >
            <div>
              <span>
                <FormattedMessage defaultMessage="Okay, got it" />
              </span>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};
SuccessClinic.propTypes = {
  clinicName: PropTypes.string.isRequired,
  closeHandler: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
};

export default withRouter(SuccessClinic);
